export default "__VITE_ASSET__JogpT7Pv__"